import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Table,
  InputNumber,
  Space,
  Spin,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth, ReferenceTypeCodes } from "_helpers";
import {
  companyService,
  materialTypeService,
  referenceService,
} from "_services";
import TabMenu from "../TabMenu";
import moment from "moment";

function Add({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [stockType, setStockType] = useState({});
  const [supplierCompanies, setSupplierCompanies] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    materialTypeService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setStockType(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
    getSupplierCompanies();
    getCurrencies();
  }, []);

  const getSupplierCompanies = () => {
    setIsLoading(true);
    companyService
      .getSuggestion("?companyTypeCodes=SUP,MSUP")
      .then((x) => {
        setIsLoading(false);
        setSupplierCompanies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCurrencies = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.CURRENCY)
      .then((x) => {
        setIsLoading(false);
        setCurrencies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsUpdating(true);
        if (values.contractStartDate) {
          values.contractStartDate = moment(values.contractStartDate).format(
            "YYYY-MM-DD"
          );
        }
        if (values.contractEndDate) {
          values.contractEndDate = moment(values.contractEndDate).format(
            "YYYY-MM-DD"
          );
        }
        delete values.lastPurchaseDate;
        delete values.lastPurchasePrice;
        const suppliers = [...(stockType.supplierCompanies || []), values];
        const payload = {
          code: stockType.code,
          secondaryCode: stockType.secondaryCode,
          name: stockType.name,
          stockClass: stockType.stockClass,
          packingType: stockType.packingType,
          materialTypeSupplierCompanies: suppliers,
        };

        console.log("OUT: ", payload);
        //console.log("OUT: ", JSON.stringify(values));
        materialTypeService
          .update(stockType.id, payload)
          .then((data) => {
            setIsUpdating(false);
            history.push(`/material-types/${stockType.id}/suppliers`);
          })
          .catch((error) => {
            setIsUpdating(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push(`/material-types/${stockType.id}/suppliers`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          key="update-confirm"
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isUpdating}>
            Save
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-types">Material Type Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Material Type: {stockType.code}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <TabMenu menu="suppliers" id={id} />
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["company", "id"]}
                    label="Supplier"
                    rules={[
                      {
                        required: true,
                        message: "Supplier is required",
                      },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {supplierCompanies.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="purchasePrice"
                    label="Purchase Price"
                    rules={[{ required: true, message: "Purchase Price" }]}
                  >
                    <InputNumber placeholder="Purchase Price" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["currency", "id"]}
                    label="Currency"
                    rules={[
                      { required: true, message: "Currency is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {currencies.length > 0 &&
                        currencies.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="minimumOrderQuantity"
                    label="Minimum Order Quantity"
                  >
                    <InputNumber placeholder="Minimum Order Quantity" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="preferredSupplier"
                    label="Preferred Supplier"
                    valuePropName="checked"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="contractStartDate"
                    label="Contract Start Date"
                  >
                    <DatePicker
                      placeholder="Contract Start Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="contractEndDate" label="Contract End Date">
                    <DatePicker
                      placeholder="Contract End Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="lastPurchasePrice"
                    label="Last Purchase Price"
                  >
                    <Input placeholder="Last Purchase Price" disabled />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="lastPurchaseDate" label="Last Purchase Date">
                    <DatePicker
                      placeholder="Last Purchase Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="remarks" label="Remarks">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
